import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule, FaLayersComponent, FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { IconService } from '@core/services/icon.service';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, FaLayersComponent, FaIconComponent],
  template: `
    <fa-layers *ngIf="withCheck" [class]="size" [fixedWidth]="true">
      <fa-icon
        [icon]="icon"
        [ngClass]="{
          'text-primary-600': color === 'primary' || color === 'success',
          'text-secondary-600': color === 'secondary',
          'text-danger-600': color === 'danger',
          'text-warning-600': color === 'warning',
        }"
      ></fa-icon>
      <fa-icon
        [icon]="checkIcon"
        transform="shrink-6 down-8 right-8"
        [ngClass]="{
          'text-primary-600': color === 'primary' || color === 'success',
          'text-secondary-600': color === 'secondary',
          'text-danger-600': color === 'danger',
          'text-warning-600': color === 'warning',
        }"
      ></fa-icon>
    </fa-layers>
    <fa-icon
      *ngIf="!withCheck"
      [icon]="icon"
      [class]="size"
      [fixedWidth]="true"
      [ngClass]="{
        'text-primary-600': color === 'primary' || color === 'success',
        'text-secondary-600': color === 'secondary',
        'text-danger-600': color === 'danger',
        'text-warning-600': color === 'warning',
      }"
    ></fa-icon>
  `,
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
    }

    .sm { font-size: 0.875rem; }
    .base { font-size: 1rem; }
    .lg { font-size: 1.25rem; }
    .md { font-size: 1.125rem; }
  `]
})
export class IconComponent implements OnInit {
  @Input() name!: string;
  @Input() size: 'sm' | 'base' | 'lg' | 'md' = 'base';
  @Input() color?: 'primary' | 'secondary' | 'danger' | 'success' | 'warning';
  @Input() withCheck?: boolean = false;

  icon!: IconDefinition;
  checkIcon!: IconDefinition;

  constructor(private iconService: IconService) {}

  ngOnInit() {
    const icon = this.iconService.getIcon(this.name);
    if (!icon) {
      console.warn(`Icon "${this.name}" not found`);
    }
    this.icon = icon || this.iconService.getIcon('circle')!;

    if (this.withCheck) {
      const check = this.iconService.getIcon('circle-check-solid');
      if (!check) {
        console.warn(`Check icon not found`);
      }
      this.checkIcon = check || this.iconService.getIcon('circle')!;
    }
  }
}
